import * as yup from 'yup';

import { FormValidationObject } from 'views/MForm/MForm.model';

export type IUserProfileSecurityFormFields = {
  is2FAEnforced: boolean;
};

export const userProfileSecurityInitialValues: IUserProfileSecurityFormFields = {
  is2FAEnforced: false,
};

export const userProfileSecurityValidationSchema = yup.object<FormValidationObject<keyof IUserProfileSecurityFormFields>>({
  is2FAEnforced: yup.boolean().required(),
});
